/**
 * Tocar o aviso abre a conversa certa no app que já está aberto.
 *
 * O service worker, ao receber o clique, procura uma janela viva e manda a
 * rota por `postMessage` em vez de abrir uma nova. Sem alguém escutando desse
 * lado, a janela é focada mas continua onde estava — a pessoa toca o aviso de
 * uma conversa e encara a lista.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface RecadoDoSW {
  type?: string;
  url?: string;
}

export function useSWNavigation(): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
      return;
    }

    const aoReceber = (evento: MessageEvent) => {
      const recado = evento.data as RecadoDoSW | undefined;
      if (recado?.type !== "navigate" || !recado.url) return;
      // Só caminho interno: um `url` absoluto vindo daqui levaria para fora do
      // app, e a origem desta mensagem é código que roda fora da página.
      if (!recado.url.startsWith("/") || recado.url.startsWith("//")) return;
      navigate(recado.url);
    };

    navigator.serviceWorker.addEventListener("message", aoReceber);
    return () =>
      navigator.serviceWorker.removeEventListener("message", aoReceber);
  }, [navigate]);
}

export default useSWNavigation;
